import { render, staticRenderFns } from "./BookCarouselPopUp.vue?vue&type=template&id=0f2bb323&scoped=true&"
import script from "./BookCarouselPopUp.vue?vue&type=script&lang=js&"
export * from "./BookCarouselPopUp.vue?vue&type=script&lang=js&"
import style0 from "./BookCarouselPopUp.vue?vue&type=style&index=0&id=0f2bb323&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2bb323",
  null
  
)

export default component.exports